export const ALL_SAVED_POSTS = "all_saved_posts";
export const NAMED_SAVED_POSTS = "saved_posts";
export const MAX_STORIES_PER_LOOKUP = 100;
export const MAX_COLLECTION_NAME_LENGTH = 255;
export const CHOOSER_AS_SHEET = "sheet";
export const CHOOSER_AS_MODAL = "modal";
export const NAME_EMPTY = "Give the collection a name.";
export const NAME_TOO_LONG = `Keep the name under ${MAX_COLLECTION_NAME_LENGTH} characters.`;

const byId = (left, right) => left.collectionId - right.collectionId;

export function savedCollectionsOf(collectionEntities) {
  const collections = Object.values(collectionEntities ?? {}).filter(collection => collection.status !== "inactive");
  const allPosts = collections.filter(collection => collection.context === ALL_SAVED_POSTS).sort(byId)[0] ?? null;
  const named = collections.filter(collection => collection.context === NAMED_SAVED_POSTS).sort(byId);
  return { allPosts, named };
}

export function chooserPresentation({ phoneWidth }) {
  return phoneWidth ? CHOOSER_AS_SHEET : CHOOSER_AS_MODAL;
}

export function collectionNameProblem(name) {
  const trimmed = String(name ?? "").trim();
  if (trimmed === "") {
    return NAME_EMPTY;
  }
  if (trimmed.length > MAX_COLLECTION_NAME_LENGTH) {
    return NAME_TOO_LONG;
  }
  return null;
}

export function statusBatches(storyIds) {
  const unique = [...new Set(storyIds.map(Number).filter(id => Number.isInteger(id) && id > 0))];
  const batches = [];
  for (let start = 0; start < unique.length; start += MAX_STORIES_PER_LOOKUP) {
    batches.push(unique.slice(start, start + MAX_STORIES_PER_LOOKUP));
  }
  return batches;
}

export function savedStatusFromAnswer(askedIds, savedStoryIds) {
  const saved = new Set((savedStoryIds ?? []).map(Number));
  return Object.fromEntries(askedIds.map(id => [id, saved.has(Number(id))]));
}
